import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1A211A] to-[#2a3a2a] p-5 font-['Inter']">
      <div className="text-center max-w-[600px]">
        <div className="text-8xl mb-8 animate-bounce">
          🌱
        </div>

        <h1 className="text-9xl font-extrabold text-[#EE9300] m-0 mb-4 leading-none drop-shadow-[0_4px_20px_rgba(238,147,0,0.4)]">
          404
        </h1>

        <h2 className="text-3xl font-bold text-white m-0 mb-4 drop-shadow-[0_2px_10px_rgba(0,0,0,0.3)]">
          Ops! Página não encontrada
        </h2>

        <p className="text-lg text-white/80 m-0 mb-12 leading-relaxed">
          Parece que você se perdeu na floresta digital. 🌳
          <br />
          Esta página não existe ou foi movida.
        </p>

        <div className="flex gap-4 justify-center flex-wrap">
          <button
            onClick={() => navigate('/Home')}
            className="px-8 py-4 rounded-xl border-none bg-gradient-to-br from-[#EE9300] to-[#ff9e00] text-white text-lg font-semibold cursor-pointer transition-all duration-300 shadow-[0_4px_15px_rgba(238,147,0,0.3)] hover:-translate-y-0.5 hover:shadow-[0_6px_20px_rgba(238,147,0,0.4)]"
          >
            🏠 Ir para Home
          </button>

          <button
            onClick={() => navigate(-1)}
            className="px-8 py-4 rounded-xl border-2 border-white/20 bg-white/10 text-white text-lg font-semibold cursor-pointer transition-all duration-300 backdrop-blur-[10px] hover:bg-white/15 hover:border-white/30"
          >
            ← Voltar
          </button>
        </div>

        <div className="mt-12">
          <p className="text-white/60 mb-4">
            Ou navegue para:
          </p>
          <div className="flex gap-6 justify-center flex-wrap">
            <a
              href="/Ranking"
              className="text-[#00A335] no-underline text-base font-medium transition-colors duration-300 hover:text-[#00d444]"
            >
              🏆 Ranking
            </a>
            <a
              href="/Posts"
              className="text-[#00A335] no-underline text-base font-medium transition-colors duration-300 hover:text-[#00d444]"
            >
              📸 Posts
            </a>
            <a
              href="/Perfil"
              className="text-[#00A335] no-underline text-base font-medium transition-colors duration-300 hover:text-[#00d444]"
            >
              👤 Perfil
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
